// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-content {
  min-height: min(62vh, 38rem);
  padding: 1.5rem;
}

.home-illustration {
  max-width: min(100%, 42rem);
}

.home-image-icon {
  display: block;
  width: 100%;
  height: auto;
  max-height: min(65vh, 32rem);
  object-fit: contain;
}

.home-title {
  max-width: 24rem;
}

@media (max-width: 767.98px) {
  .home-content {
    min-height: auto;
    padding: 1rem;
  }

  .home-image-icon {
    max-height: 42vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/pages/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".home-content {\n  min-height: min(62vh, 38rem);\n  padding: 1.5rem;\n}\n\n.home-illustration {\n  max-width: min(100%, 42rem);\n}\n\n.home-image-icon {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: min(65vh, 32rem);\n  object-fit: contain;\n}\n\n.home-title {\n  max-width: 24rem;\n}\n\n@media (max-width: 767.98px) {\n  .home-content {\n    min-height: auto;\n    padding: 1rem;\n  }\n\n  .home-image-icon {\n    max-height: 42vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
